module.exports = __webpack_public_path__ + "static/media/Brunch.aebac0f6.svg";